__turbopack_context__.v({
  "OfferTimeout": "OfferTimeout-module__6yxAPq__OfferTimeout",
  "Timeout": "OfferTimeout-module__6yxAPq__Timeout",
  "last": "OfferTimeout-module__6yxAPq__last",
  "text": "OfferTimeout-module__6yxAPq__text",
});
